import React, { useEffect, useState } from 'react';

import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import './History.css';

export default function History() {

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);


  return (
    <>
      <div><Navbar/></div>

      <section id="nadi-history">
        <h1>History of Nadi Astrology</h1>
        
        <p>
          Nadi Astrology is one of the oldest and most mystical forms of astrology, which traces its origins back to ancient India, particularly in Tamil Nadu...
        </p>

        <h2>Origins of Nadi Astrology</h2>
        <p>
          Nadi Astrology has roots that date back over 2000 years...
        </p>
        
        <h3>Founders and Sages of Nadi Astrology</h3>
        <p>
          The tradition of Nadi Astrology is most closely associated with the sage Agastya...
        </p>
        
        <h4>Notable Sages Involved in Nadi Astrology:</h4>
        <ul>
          <li><strong>Sage Agastya:</strong> One of the first sages...</li>
          <li><strong>Sage Bhrigu:</strong> His Nadi texts...</li>
          <li><strong>Sage Kousika:</strong> Another sage...</li>
        </ul>

        <h2>Discovery of Nadi Leaves</h2>
        <p>
          The Nadi leaves were discovered in Tamil Nadu, specifically in Vaitheeswaran Koil...
        </p>

        <h3>Process of Discovering Nadi Leaves:</h3>
        <p>
          These leaves were originally believed to be protected in secret places...
        </p>

        <h4>Key Points About the Nadi Leaves:</h4>
        <ul>
          <li>The leaves are inscribed in ancient Tamil...</li>
          <li>The information recorded includes details about the person’s family...</li>
        </ul>

        <h2>How Nadi Astrology Works</h2>
        <p>
          Nadi Astrology is a highly personalized form of astrology...
        </p>

        <h3>Detailed Steps in Nadi Reading:</h3>
        <ol>
          <li>The individual’s thumb impression is taken...</li>
          <li>The thumb impression is matched...</li>
        </ol>

        <h2>Significance of Nadi Astrology</h2>
        <p>
          Nadi Astrology holds a unique place in the world of astrology...
        </p>

        <h3>Reasons Why Nadi Astrology is Significant:</h3>
        <ul>
          <li><strong>Accuracy:</strong> Nadi astrology readings...</li>
          <li><strong>Connection with Ancient Wisdom:</strong> Nadi astrology...</li>
        </ul>

        <h2>The Modern-Day Practice of Nadi Astrology</h2>
        <p>
          Today, Nadi Astrology continues to be practiced by a small group of astrologers...
        </p>

        <h3>Modern-Day Adaptations of Nadi Astrology:</h3>
        <ul>
          <li><strong>Digitization:</strong> Some Nadi manuscripts have been digitized...</li>
          <li><strong>International Appeal:</strong> Nadi astrology is now known worldwide...</li>
        </ul>

        <h2>Conclusion</h2>
        <p>
          Nadi Astrology continues to capture the interest of people worldwide...
        </p>
      </section>

      {/* <div><Footer/></div> */}
    </>
  )
}
